export default "__VITE_ASSET__0f855256__"